module.exports = __webpack_public_path__ + "img/oaFlowData201@3x.20d1d833.png";